export default {
  Login: {
    /* 登录 */
    login: "login",
    /* 登出 */
    loginOut: "logout",
    captcha: "login/captcha",
    sendMqtt: "h5Interface/sendMqtt"
  },
  Index: {
    main: "index/main",
    machineInfo: "system/getEquipmentExpired"
  },

  AuthorityUser: {
    /* 添加用户 */
    addUser: "user/insert3",
    /* 修改用户 */
    editUser: "user/update3",
    /* 获取用户信息 */
    pageList: "user/page",
    /* {{$t('common.reset')}}密码${id} */
    resetPassword: "user/reset",
    /* 启用禁用账号${id}/${enable} */
    enabled: "user/enabled",
    delete: "user/delete",
    export: "user/export",
    importUser: "user/importUser",
    getVerifyCode: "user/getVerifyCode"
  },
  IconList: {
    /* 加载图标 */
    loadIcon: "system/listIcon"
  },
  User: {
    page: "user/page",
    insert: "user/insert",
    update: "user/update",
    updatePassword: "user/updatePassword",
    checkPassword: "user/checkPassword",
    resetPassword: "user/rechargePassword",
    getConfigByUserId: "paypalSetting/getByUserId",
    getCashuConfigByUserId: "cashuConfig/getByUserId",
    getPaymentWallConfigByUserId: "paymentWall/config/getByUserId",
    updatePaymentWallConfig: "paymentWall/config/update",
    insertPaymentWallConfig: "paymentWall/config/insert",
    getGccPayConfigByUserId: "gccPay/config/getByUserId",
    updateGccPayConfig: "gccPay/config/update",
    insertGccPayConfig: "gccPay/config/insert",
    addPaypal: "paypalSetting/insert",
    addCanshu: "cashuConfig/insert",
    editPaypal: "paypalSetting/update",
    editCanshu: "cashuConfig/update",
    uploadAvatar: "user/uploadAvatar",
    findPassword: "user/forgotPwd/update",
    validPass: "user/validPass",
    listUserByUsername: "user/list",
    selectUser: "user/select",
    deductAmount: "user/deductAmount",
    verifyUser: "user/forgotPwd/sendCode", // 验证手机号是否绑定用户账号
    listUserByParent: "user/listUserByParent",
    getUserById: "user/getUserById",
    listFinance: "user/listFinance3",
    loginJump: "user/accountRedirection",
    getByList: "role/list",
    domianmodify: "user/update/loginLocale",
    export: "user/export"
  },
  AuthorityMenu: {
    /* 加载地址url */
    list: "menu/list",
    insert: "menu/insert",
    update: "menu/update",
    delete: "menu/delete",
    listByPid: "menu/listByPid",
    updateInMenu: "menu/updateInMenu",
    listMenuName: "menu/listMenuName"
  },
  AuthorityMenuUrl: {
    load: "menuUrl/load",
    loadUrl: "menuUrl/loadUrl",
    update: "menuUrl/update"
  },
  AuthorityRole: {
    load: "role/page",
    loadRole: "role/list",
    save: "role/insert",
    update: "role/update",
    listByRole: "role/page",
    delete: "role/delete",
    listByPid: "role/list",
    updateInList: "role/updateInList",
    listRoleByUserType: "role/listRoleByUserType3"
  },
  AuthorityRoleMenu: {
    load: "menu/list",
    listMenu: "menu/getMenIdsByRoleId",
    update: "roleMenu/update",
    save: "role/configMenu",
    listAuth: "roleMenu/listAuth"
  },
  AuthorityUserRole: {
    load: "userRole/list",
    update: "userRole/update",
    save: "user/configRole",
    pageUserByRoleId: "user/page",
    listRoleByUserId: "role/list",
    clearRole: "user/clearRole"
  },
  AuthorityCommonUrl: {
    load: "commonUrl/list",
    update: "commonUrl/update",
    loadOpen: "commonUrl/listOpen"
  },
  Message: {
    load: "message/load"
  },
  Notice: {
    getUser: "socket/getUser",
    kickOut: "socket/kickOut",
    sendUser: "socket/sendUser",
    banned: "socket/banned"
  },
  LoginInfo: {
    page: "loginRecord/page",
    delete: "loginRecord/delete",
    clear: "loginInfo/clear"
  },
  OperationLog: {
    page: "systemActivityLog/page",
    delete: "systemActivityLog/delete"
  },
  File: {
    upload: "file/upload"
  },
  DictType: {
    loadDictType: "codes/page",
    list: "codes/list",
    save: "codes/insert",
    update: "codes/update",
    delete: "codes/delete"
  },
  DictData: {
    page: "codesValue/page",
    save: "codesValue/insert",
    update: "codesValue/update",
    delete: "codesValue/delete",
    listDictData: "codesValue/list",
    listLabel: "codesValue/getLabelById"
  },
  Machine: {
    page: "equipment/page",
    getMachineNo: "equipment/getMachineNo",
    insert: "equipment/insert",
    insertBatch: "equipment/insertBatch",
    update: "equipment/update",
    delete: "equipment/delete",
    recover: "equipment/recover",
    userRecover: "userEquipment/recover",
    import: "equipment/import",
    export: "equipment/export",
    template: "equipment/template",
    machineList: "equipment/list",
    select: "userEquipment/select",
    extendSubscription: "userEquipment/extendSubscription",
    updateWtiSerial: "equipment/updateWtiSerial",
    wtiInfo: "equipment/wtiInfo",
    wtiSimAction: "equipment/wtiSimAction",
    wtiEsimAction: "equipment/wtiEsimAction",
    wtiPing: "equipment/wtiPing",
    wtiReboot: "equipment/wtiReboot",
    wtiDescription: "equipment/wtiDescription"
  },
  MachineGroup: {
    page: "equipmentTeam/page",
    update: "equipmentTeam/update",
    insert: "equipmentTeam/insert",
    list: "equipmentTeam/list",
    moveGroup: "equipmentTeam/giveEquipment",
    delete: "equipmentTeam/delete"
  },
  MachineType: {
    page: "equipmentType/page",
    update: "equipmentType/update",
    insert: "equipmentType/insert",
    list: "equipmentType/list"
  },
  MachineRecord: {
    page: "equipmentTakeRecord/page",
    online: "mqtt/record/page"
  },
  OffLineRecord: {
    page: "mqttRecord/page"
  },
  UserMachine: {
    saveError: "aisleGoods/exceptionHandling",
    unBindMac: "userEquipment/splitScreen/unbind",
    updateWtiSerial: "userEquipment/updateWtiSerial",
    wtiSimStatus: "userEquipment/wtiSimStatus",
    page: "userEquipment/page",
    upPage: "userEquipment/apk/page",
    goodsList: "goods/list",
    errorLook: "aisleGoods/page",
    update: "userEquipment/update",
    updatePos: "userEquipment/positioning",
    list: "equipment/list",
    userList: "userEquipment/list",
    fetchMachineDetails: "userEquipment/fetchMachineDetails",
    listUser: "user/list",
    updateGroupId: "userEquipmentTeam/addOrRemoveEquipment",
    updateLabelId: "userEquipmentLabelTeam/addOrRemoveEquipment",
    listProduct: "aisleGoods/page",
    listUserMachineByGroupId: "userEquipment/list",
    listUserMachineSelect: "userEquipment/select",
    export: "userEquipment/export",
    deposit: "userEquipment/deposit",
    returnDeposit: "userEquipment/returnDeposit",
    payment: "userEquipment/payConfig",
    config: "userEquipment/batchAisleGoods",
    control: "userEquipment/remote",
    getcontrol: "userEquipment/remoteState",
    closeNetWork: "userEquipment/closeNetWork",
    openNetWork: "userEquipment/openNetWork",
    gmodify: "userEquipmentTeam/config",
    modify: "userEquipment/config",
    merge: "machine/line/product/merge",
    lastDeliveredTransactions: "userEquipment/lastDeliveredTransactions",
    relieve: "machine/line/product/merge/relieve",
    getQrCode: "userEquipment/getQrCode",
    sendMqtt: "userEquipment/sendLog",
    androidlog: "apkLog/page",
    userEquipment: "userMoveGroup/userEquipment",
    payRecord: "userEquipment/statRecord",
    payRecordClear: "userEquipment/statRecord/clear",
    getProduct: "product/getByPage",
    getCargoway: "machine/line/product/getByPage",
    ProductModeList: "machine/line/product/getByProductModeList",
    DeleteProductMode: "machine/line/product/deleteProductMode",
    SaveProductMode: "machine/line/product/saveProductMode",
    getCode: "userEquipment/electricLockSendCode",
    validCode: "userEquipment/electricLockValidCode",
    electricLockDirect: "userEquipment/electricLockDirect",
    saveRenvel: "userEquipment/commission/save",
    reStartBoard: "userEquipment/restart"
  },
  Map: {
    data: "map/userEquipment"
  },
  Notes: {
    test: "notes/test",
    add: "notes/add",
    getByMachineId: "notes/getByMachineId",
    getByMachineNo: "notes/getByMachineNo",
    update: "notes/update",
    updateByMachineNo: "notes/updateByMachineNo",
    updateAddressByEquipmentNo: "notes/updateAddressByEquipmentNo"
  },
  UserMachineGroup: {
    page: "userEquipmentTeam/page",
    choosePage: "userEquipment/select",
    list: "userEquipmentTeam/list",
    fetchGroupMachines: "userEquipment/fetchGroupMachines",
    getMachineGroup: "userEquipmentTeam/getMachineGroup",
    insert: "userEquipmentTeam/insert",
    update: "userEquipmentTeam/update",
    moveUserMachine: "userEquipmentTeam/giveEquipment",
    userMoveGroup: "userMoveGroup/page",
    userMoveGroupInsert: "userMoveGroup/insert",
    userMoveGroupUpdate: "userMoveGroup/update",
    delete: "userEquipmentTeam/delete"
  },
  UserMachineLabels: {
    page: "userEquipmentLabelTeam/page",
    list: "userEquipmentLabelTeam/list",
    choosePage: "userEquipment/select",
    insert: "userEquipmentLabelTeam/insert",
    update: "userEquipmentTeam/update",
    moveUserMachine: "equipmentTeam/moveGroup",
    userMoveGroup: "userMoveGroup/page",
    userMoveGroupInsert: "userMoveGroup/insert",
    userMoveGroupUpdate: "userMoveGroup/update",
    delete: "userEquipmentLabelTeam/delete"
  },
  ShippingOrder: {
    page: "shippingOrder/page",
    list: "shippingOrder/list",
    insert: "shippingOrder/insert",
    update: "shippingOrder/update",
    delete: "shippingOrder/delete",
    getEquipmentTeamByOrderId: "shippingOrder/getEquipmentTeamByOrderId",
    getEquipmentByTeamId: "shippingOrder/getEquipmentByTeamId",
    getPrintInfoByEquipmentId: "shippingOrder/getPrintInfoByEquipmentId"
  },
  ProductType: {
    page: "goodsType/page",
    insert: "goodsType/insert",
    update: "goodsType/update",
    list: "goodsType/list",
    delete: "goodsType/delete"
  },
  ProductTag: {
    page: "goodsTag/page",
    insert: "goodsTag/insert",
    update: "goodsTag/update",
    list: "goodsTag/list",
    delete: "goodsTag/delete"
  },
  ProductSpecify: {
    page: "product/spec/page",
    insert: "product/spec/insert",
    update: "product/spec/update",
    delete: "product/spec/delete"
  },
  Product: {
    page: "goods/page",
    list: "product/list",
    insert: "goods/insert",
    update: "goods/update",
    delete: "goods/delete",
    listProductTag: "product/listProductTag",
    insertCoupons: "discount/insert",
    getCoupons: "discount/page",
    getCouponsKpi: "discount/kpi",
    deleteCoupon: "discount/delete",
    getCouponsCode: "discountCode/page",
    exportCoupon: "discount/export",
    exportCouponMa: "discountCode/export",
    symbol: "paypal/currency/symbol/list",
    speclist: "product/spec/list",
    select: "goods/select"
  },
  MachineLineProduct: {
    update: "aisleGoods/update",
    subSpec: "product/subSpec/list",
    export: "aisleGoods/export"
  },
  Adverts: {
    page: "ad/page",
    delete: "ad/delete",
    insert: "ad/insert",
    update: "ad/update",
    listAdvertByGroupId: "ad/list"
  },
  PaidAd: {
    page: "PaidAd/page",
    list: "PaidAd/list",
    insert: "PaidAd/insert",
    update: "PaidAd/update",
    delete: "PaidAd/delete"
  },
  AdvertGroup: {
    page: "adTeam/page",
    list: "adTeam/list",
    insert: "adTeam/insert",
    update: "adTeam/update",
    advertConfig: "adTeam/config",
    updateAdvertConfig: "adTeam/config/save",
    delete: "adTeam/delete"
  },
  userEquipmentAd: {
    adsList: "userEquipmentAd/listAvailableAds",
    assignAds: "userEquipmentAd/assignAds",
    removeAds: "userEquipmentAd/removeAds",
    removeAssignmentRows: "userEquipmentAd/removeAssignmentRows",
    editPaidAd: "userEquipmentAd/editPaidAd",
    galleryAdAssign: "userEquipmentAd/galleryAdAssign",
    page: "userEquipmentAd/page",
    editAdDate: "userEquipmentAd/editAdDate",
    deleteEquipmentAd: "userEquipmentAd/deleteEquipmentAd",
    machinesWithAds: "userEquipmentAd/machinesWithAds",
    adsByEquipment: "userEquipmentAd/adsByEquipment",
    deleteAdGallery: "userEquipmentAd/deleteAdGallery"
  },
  MachineAdvertGroup: {
    page: "userEquipmentAdTeam/page",
    insert: "userEquipmentAdTeam/insert",
    update: "userEquipmentAdTeam/update",
    delete: "userEquipmentAdTeam/delete"
  },
  AdTeamConfig: {
    saveConfig: "userEquipmentAd/ad-team/save-config",
    assign: "userEquipmentAd/ad-team/assign",
    getConfig: "userEquipmentAd/ad-team/config"
  },
  MachineAdvertGroupLabel: {
    page: "userEquipmentLabel/page",
    insert: "userEquipmentLabel/insert",
    update: "userEquipmentLabel/update",
    delete: "userEquipmentLabel/delete"
  },
  AppVersion: {
    page: "apkVersion/page",
    listAppVersion: "apkVersion/list",
    insert: "app/version/insert",
    update: "apkVersion/update"
  },
  machineVersion: {
    page: "apkVersion/page",
    listMachineVersion: "app/version/listMachineVersion",
    insert: "app/version/insert",
    update: "apkVersion/update"
  },
  Order: {
    page: "order/page",
    export: "order/export",
    refund: "order/refund",
    refundByOrderId: "order/refund"
  },
  RefundRecord: {
    page: "ordersRefund/page"
  },
  AlarmRecord: {
    page: "equipmentFaultRecord/page",
    noticeType: "userEquipment/alarmRecord/noticeType",
    noticeTypeList: "userEquipment/alarmRecord/noticeTypeList"
  },
  Upload: {
    product: "upload/goods",
    advert: "upload/ad",
    appIcon: "upload/img/Icon",
    app: "upload/apk",
    join: "upload/joinUser",
    renew: "upload/img/rent",
    wallet: "upload/wallet",
    setting: "upload/logo",
    sdfile: "upload/3d",
    feedback: "upload/feedback",
    theme: "upload/style",
    smokeCard: "smokeCard/upload",
    bouncer: "upload/bouncer",
    icewm: "upload/towel"
  },
  Join: {
    page: "joinPay/page",
    insert: "joinPay/insert",
    update: "joinPay/update",
    picsInfo: "joinPay/picsInfo",
    querySignContent: "joinPay/querySignContent",
    joinSign: "joinPay/joinSign",
    queryJoinOrder: "joinPay/queryJoinOrder",
    queryJoinRefundOrder: "joinPay/queryJoinRefundOrder",
    queryBalance: "joinPay/queryBalance"
  },
  Deposit: {
    page: "depositRefund/page",
    insert: "depositRefund/insert"
  },
  CashBack: {
    page: "cashBack/page"
  },
  CashBackRecord: {
    page: "cashBackRecord/page",
    insert: "cashBackRecord/insert"
  },
  AgentProfit: {
    page: "agentProfit/page",
    cashPrice: "agentProfit/cashPrice"
  },
  RenewalRecord: {
    page: "rentRecord/page",
    insert: "rentRecord/insert",
    getPayList: "userEquipment/getRentPrice",
    getPayConfig: "money/bankInfo",
    update: "rentRecord/update",
    renew: "rentRecord/confirm",
    revokeRenew: "rentRecord/cancel",
    renewalPAYPAL: "pay/PAYPAL/WEB",
    recordGetById: "rentRecord/getById",
    calculateCostRenewal: "rentRecord/calculateCostRenewal",
    export: "rentRecord/export"
  },
  RechargeRecord: {
    getPayConfig: "money/bankInfo",
    insert: "moneyOrder/insert",
    rechargePAYPAL: "pay/PAYPAL/WEB",
    update: "moneyOrder/update",
    recharge: "moneyOrder/page",
    confirm: "moneyOrder/confirm",
    revokeRecharge: "moneyOrder/cancel",
    getById: "moneyOrder/getById"
  },
  ICard: {
    page: "iCard/page",
    insert: "iCard/insert",
    update: "iCard/update",
    import: "iCard/import",
    template: "iCard/template",
    delete: "iCard/delete",
    reset: "iCard/reset"
  },
  IDard: {
    applyIDard: "cert/apply",
    insertIDard: "cert/insert",
    updateIDard: "cert/update",
    deleteIDard: "cert/delete",
    pageIDard: "cert/page",
    cert: "upload/cert",
    jzupload: "h5Interface/upload"
  },
  FinanceGroup: {
    page: "finance/group/page",
    insert: "finance/group/insert",
    update: "finance/group/update",
    listFinance: "finance/group/listFinance",
    delete: "finance/group/delete"
  },
  Statistics: {
    machine: "statistics/machine",
    product: "statistics/product",
    user: "stat/user/table",
    date: "statistics/date",
    exportMachine: "statistics/exportMachine",
    exportProduct: "statistics/exportProduct",
    exportUser: "stat/user/export",
    exportDate: "statistics/exportDate",
    advertRecord: "advertRecord/pay/page",
    advertRecordExport: "advertRecord/pay/export",
    alarmRecord: "equipmentFaultRecord/count",
    alarmRecordPage: "equipmentFaultRecord/page"
  },
  myWallet: {
    wallet: "money/get",
    recharge: "recharge/getById",
    walletlog: "MoneyLog/page",
    export: "MoneyLog/export",
    wInsert: "userWithdrawal/insert",
    page: "userWithdrawal/page",
    cancel: "userWithdrawal/cancel",
    confirm: "userWithdrawal/confirm",
    account: "moneyUse/page",
    moneyPage: "money/page",
    detail: "moneyUse/page",
    recordexport: "moneyUse/export"
  },
  InventoryLog: {
    page: "inventoryLog/page"
  },
  Email: {
    save: "systemConfig/save"
  },
  // 列表页保存的筛选视图（复用 sys_config，type=FILTER_VIEW）
  // UI 切换原因反馈
  UiSwitchFeedback: {
    insert: "uiSwitchFeedback/insert"
  },
  FilterView: {
    get: "systemConfig/get",
    save: "systemConfig/save"
  },
  Promote: {
    save: "systemConfig/save",
    get: "systemConfig/get",
    getDefault: "systemConfig/default",
    getDictValue: "codesValue/list"
  },
  // 运营者专属优惠（Perks）——与移动端 VTM Wholesale 同一套 promotion 接口。
  // gallery / flavors / requirements 服务端以 JSON 文本存储，读取时需 JSON.parse。
  Promotion: {
    page: "promotion/page",
    detail: "promotion/detail",
    insert: "promotion/insert",
    update: "promotion/update",
    delete: "promotion/delete"
  },
  Upgrade: {
    listAppVersion: "app/version/listAppVersion",
    listAppPage: "apkVersion/page",
    listFirmware: "vmc/list",
    appInsert: "apkVersion/insert",
    appUpdate: "apkVersion/update",
    firmware: "vmc/page",
    firmwareInsert: "vmc/insert",
    firmwareupdate: "vmc/update",
    firmwareupload: "upload/vmc",
    updateIp: "userEquipment/updateIp",
    appVersion: "userEquipment/apkUp",
    firmwareVersion: "userEquipment/vmcUp",
    appVersionMore: "userEquipment/apkUpMore",
    firmwareVersionMore: "userEquipment/vmcUpMore",
    firmwareStatus: "userEquipment/vmcUpStatus",
    appStatus: "userEquipment/apkUpStatus",
    appDownConfig: "app/version/app/down",
    superAdminPwdChange: "app/version/apk/super/save",
    appList: "apkVersion/page",
    appInsert2: "app/version/app/insert",
    appExit: "app/version/app/update",
    appDownConfigSave: "app/version/app/down/save",
    allUser: "app/version/role/user",
    updateFlag: "apkVersion/update",
    saveUser: "app/version/role/save",
    oneKeyUp: "apkVersion/upgrade/failure"
  },
  Feedback: {
    insert: "feedback/insert",
    page: "feedback/page",
    deletes: "feedback/delete",
    update: "feedback/update",
    export: "feedback/export"
  },
  Grouptransfer: {
    delete: "userMoveGroup/delete"
  },
  Advertising: {
    grouppage: "adPlanTeam/page",
    groupinsert: "adPlanTeam/insert",
    groupupdate: "adPlanTeam/update",
    groupdelete: "adPlanTeam/delete",
    advertconfig: "adPlanTeam/config",
    updateAdvertConfig: "adPlanTeam/config/save",
    planpage: "adPlan/page",
    planinsert: "adPlan/insert",
    planupdate: "adPlan/update",
    plandelete: "adPlan/delete",
    countpage: "adPlanStat/page"
  },
  TowelCard: {
    page: "towelCard/page",
    insert: "towelCard/insert",
    update: "towelCard/update",
    delete: "towelCard/delete",
    flow: "towelCard/flow",
    dtemplate: "towelCard/template",
    import: "towelCard/import",
    getCode: "towelCode/get",
    saveCode: "towelCode/save"
  },
  Ecigarette: {
    smokeCard: "smokeCard/page",
    insert: "smokeCard/insert",
    update: "smokeCard/update",
    delete: "smokeCard/delete",
    flow: "smokeCard/flow",
    dtemplate: "smokeCard/template",
    import: "smokeCard/import"
  },
  Theme: {
    themepage: "equipmentStyle/page",
    machinepage: "userEquipment/page",
    machineSelect: "userEquipment/select",
    configmachine: "equipmentStyle/config",
    themeinsert: "equipmentStyle/insert",
    themeupdate: "equipmentStyle/update",
    adminThemeUpdate: "equipmentStyle/admin/save",
    themedelete: "equipmentStyle/delete",
    getDefault: "equipmentStyle/system/default",
    getCreateDefault: "equipmentStyle/create/default",
    getAdmin: "equipmentStyle/admin/default"
  },
  Consoles: {
    getMachine: "dashboard/equipment",
    getSales: "dashboard/sales",
    getAlarm: "dashboard/fault",
    getSalesUser: "dashboard/user/ranking",
    getSalesProduct: "dashboard/goods/ranking",
    getSalesMachine: "dashboard/equipment/ranking",
    getSalesDay: "dashboard/sales/day",
    getProportion: "dashboard/proportion"
  },
  Temperature: {
    temperature: "userEquipment/temperature",
    modifyTemperature: "userEquipment/updateById",
    temperatureitem: "userEquipment/temperature/item",
    export: "userEquipment/temperature/item/export"
  },
  Bouncer: {
    userMachineBouncer: "userMachineBouncer/page",
    customUserMachineBouncer: "userMachineAgeRecognition/page",
    setLink: "userMachineAgeRecognition/update"
  },
  MachineProfit: {
    statisticsday: "stat/equipment/day",
    statisticstop: "stat/equipment/ranking",
    statisticstable: "stat/equipment/table",
    export: "stat/equipment/export",
    statisticsday2: "userEquipment/page",
    allshops: "goods/list"
  },
  ProductProfit: {
    statisticsday: "stat/goods/day",
    statisticstop: "stat/goods/ranking",
    statisticstable: "stat/goods/table",
    export: "stat/goods/export"
  },
  DateProfit: {
    getSales: "dashboard/sales",
    day: "stat/date/day",
    date: "stat/date/table",
    export: "stat/date/export"
  },
  AdverStatistics: {
    advert: "stat/ad",
    day: "stat/ad/day",
    advertRecord: "stat/ad/table",
    export: "stat/ad/export"
  },
  MyApps: {
    fsList: "userEquipment/splitScreen/page",
    chooseMachine: "userEquipment/splitScreen/check",
    delMachine: "userEquipment/splitScreen/delete",
    fsConfig: "userEquipment/splitScreen/config",
    activityList: "promotion/page",
    delActivity: "promotion/delete",
    upload: "upload/promotion",
    getMachine: "promotion/search/userEquipment",
    getLineShop: "aisleGoods/page",
    getCoupon: "discount/page",
    insertActivity: "promotion/insert",
    exitActivity: "promotion/update",
    endActivity: "promotion/done",
    couponList: "coupon/item/page",
    recordList: "promotion/winner/page"
  },
  TemporaryStorageCertificate: {
    list: "age/page",
    del: "age/delete"
  },
  Association: {
    userList: "user/getUserByPage",
    association: "userRelevance/insert",
    associatedList: "userRelevance/getByPage",
    delAssociated: "userRelevance/delete"
  },
  DealerAuthority: {
    load: "userMenu/list3",
    authed: "userMenu/listMenuAndModule",
    saveHideAuth: "userMenu/insert"
  },
  common: {
    upload: "upload/img/common"
  },
  ProductLibrary: {
    page: "goodsLib/page",
    delete: "goodsLib/delete",
    insert: "goodsLib/insert",
    update: "goodsLib/update"
  },
  AdLibrary: {
    page: "adLib/page",
    list: "adLib/list",
    insert: "adLib/insert",
    update: "adLib/update",
    delete: "adLib/delete"
  },
  PrivacyAgreement: {
    Inquiry: "agreementLog/getStatus",
    agree: "agreementLog/agreed",
    page: "agreementLog/page",
    delete: "agreementLog/delete"
  },
  // API & AI 页面（前端静态路由 /developers）：自助 API 密钥、AI 助手连接（MCP）、用量
  ApiKey: {
    access: "apiKey/access",
    list: "apiKey/list",
    create: "apiKey/create",
    revoke: "apiKey/revoke",
    usage: "apiKey/usage",
    adminUsage: "apiKey/adminUsage"
  },
  Stripe: {
    add: "user/addStripe",
    create: "pay/STRIPE/WEB",
    machineGetUrl: "/user/getStripePortalSession",
    checkPayment: "userStripe/checkPayment",
    cancelSubscriptionItem: "userStripe/cancelSubscriptionItem",
    consolidate: "userStripe/consolidate",
    consolidateUser: "userStripe/consolidateUser",
    consolidateAll: "userStripe/consolidateAll"
  }
};
